import { ConfigureNetworkPage } from "fleet/view/network/configure";
import { ConfigureNetworkPageV2 } from "fleet/view/network/configure-v2-page";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import {
  applicationsSelector,
  installedAppsSelector,
} from "redux-store/applications";
import { getAuthUser } from "redux-store/auth/selectors";
import {
  addErrorMessageAction,
  addSuccessMessageAction,
} from "redux-store/messages";
import { EDIT_NETWORK_PARAMS } from "redux-store/networks/actions";
import { networksSelector } from "redux-store/networks/selectors";
import { makeGetAllAsArray } from "redux-store/selectors";
import { isReadonly } from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";
import { Features } from "ui/features";

const getAllAppsAsArray = makeGetAllAsArray();

function mapStateToProps(state, props) {
  const { id } = props.match.params || {};

  const storesLoaded = storesReady(state.global.networks);
  const appById = applicationsSelector(state);
  const networks = networksSelector(state);
  const user = getAuthUser(state);

  const apps = getAllAppsAsArray({ byId: appById });
  const installedApps = installedAppsSelector(apps);
  const network = networks[id];
  const readonly = isReadonly(user);

  return {
    network,
    readonly,
    storesLoaded,
    apps: installedApps,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addErrorMessage: (msg) => {
      dispatch(addErrorMessageAction(msg));
    },
    updateParams: (serviceArgs) => {
      return createPromiseApiAction(dispatch, EDIT_NETWORK_PARAMS, [
        serviceArgs.id,
        serviceArgs.params,
      ]).then(() => {
        dispatch(
          addSuccessMessageAction("Success! Network parameters updated."),
        );
      });
    },
  };
}

const isParamV3Enabled = Features.isEnabled(
  Features.constants.APP_PARAMETERS_V3,
);
const Page = isParamV3Enabled ? ConfigureNetworkPageV2 : ConfigureNetworkPage;
const ConnectedConfigureNetworkPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Page);

export { ConnectedConfigureNetworkPage };
